<template>
  <svg
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.85898 20.2887L40 0.57735L74.141 20.2887V59.7113L40 79.4226L5.85898 59.7113V20.2887Z"
      fill="#272727" />
    <path
      d="M40.8338 39.1667L74.6414 20V60L40.0004 80L5.35938 60L40.8338 39.1667Z"
      fill="#1B1B1B" />
    <path
      d="M5.85898 20.2887L40 0.57735L74.141 20.2887V59.7113L40 79.4226L5.85898 59.7113V20.2887Z"
      stroke="#3B3B3B" />
  </svg>
</template>
